module.exports = __webpack_public_path__ + "static/media/fragomen-ireland-ltd.c698ed0d.png";